import { render, staticRenderFns } from "./bindPageDialog.vue?vue&type=template&id=387e14f2"
import script from "./bindPageDialog.vue?vue&type=script&lang=js"
export * from "./bindPageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports